<template lang="pug">
  div(:class="['widget', {'border-error': error}]")

    v-container
      v-layout
        span(class="subheading") Issues

      template(v-if="loading")
        v-layout(align-center justify-center fill-height)
          v-progress-circular(size="50" indeterminate)

      template(v-else)
        v-container(style="padding: 12px 24px 0 24px;")
          table(style="table-layout: fixed; width: 100%;")
            tr
              td(colspan="3" class="text-xs-left grey--text")
                | ID (+description)
              td(class="text-xs-right grey--text") Start
              td(class="text-xs-right grey--text") Duration
            tr(v-for="issue in issues" :key="issue.id")
              td(colspan="3")
                v-tooltip(right)
                  router-link(slot="activator"
                              :to="{ name: 'issue', params: { id: issue.id } }"
                              class="clickable")
                    | {{ issue.id | formatIId }}
                  span {{ issue.description }}
              td(class="text-xs-right")
                v-tooltip(left)
                  span(slot="activator") {{ issue.dateRaised | formatFn }}
                  span {{ issue.dateRaised | formatLLL }}
              td(:class="['text-xs-right',\
                        { 'blink red--text text--accent-3': !issue.dateClosed }\
                                                                             ]")
                v-tooltip(v-if="issue.dateClosed" left)
                  span(slot="activator")
                    | {{ [issue.dateClosed, issue.dateRaised] | duration }}
                  span {{ issue.dateClosed | formatLLL }}
                span(v-else)
                  | {{ [issue.dateClosed, issue.dateRaised] | duration }}

</template>

<script>
import moment from "moment";

export default {
  name: "issues",
  filters: {
    duration (val) {
      const end = val[0] ? moment(val[0]) : moment();
      const start = moment(val[1]);
      return moment.duration(start.diff(end)).humanize();
    }
  },
  data () {
    return {
      error: false,
      issues: [],
      loading: false
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/issues?site=${this.$route.params.id}`).
      then((r) => this.issues = r.data.reverse()).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>

<style scoped>
.blink {
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Site/Issues.vue